import { PAGES_ACTIONS, initialPagesState } from './pages.types';
export function pagesReducer(state = initialPagesState, action) {
    switch (action.type) {
        case PAGES_ACTIONS.SET_PAGES:
            return { ...state, data: action.payload };
        case PAGES_ACTIONS.SET_PAGE:
            return { ...state, current: action.payload };
        case PAGES_ACTIONS.ADD_PAGE:
            return { ...state, data: { ...state.data, [action.payload.id]: action.payload } };
        case PAGES_ACTIONS.UPDATE_PAGE:
            return {
                ...state,
                data: { ...state.data, [action.payload.id]: action.payload },
                current: state.current?.id === action.payload.id ? action.payload : state.current
            };
        case PAGES_ACTIONS.REMOVE_PAGE: {
            return {
                ...state,
                data: Object.fromEntries(Object.entries(state.data).filter(([id]) => Number(id) !== action.payload))
            };
        }
        case PAGES_ACTIONS.SET_STATUS:
            return { ...state, status: action.payload };
        case PAGES_ACTIONS.SET_CURRENT_STATUS:
            return { ...state, currentStatus: action.payload };
        case PAGES_ACTIONS.SET_ERRORS:
            return { ...state, errors: [action.payload, ...state.errors] };
        case PAGES_ACTIONS.CLEAR_ERRORS:
            return { ...state, errors: [] };
        case PAGES_ACTIONS.CLEAR_PAGES:
            return { ...state, data: {} };
        case PAGES_ACTIONS.CLEAR_CURRENT:
            return { ...state, current: null, currentStatus: 'idle' };
        default:
            return state;
    }
}
